export default "/_next/static/chunks/fonts/IBM Plex Sans Medium-a3f7b989ece8d63dc663ee0963e4d920.ttf";